import * as React from 'react';
import View from './view';
import {ProductsCategoryFilterViewBaseProps} from '../../../model';

export const ProductsCategoryFilterVisuallyImpaired: React.FC<ProductsCategoryFilterViewBaseProps> = (props) => {
  return <View {...props} />;
};
